export enum BannerAction {
  DIRECT_LINK,
  CATEGORY_LINK,
  STORE_LINK,
  PRODUCT_LINK,
}
